import http from '@/lib/http.js';
import axios from 'axios';

var ignoreList = ['127.0.0.1', 'https://127.0.0.1'];

var store = {
	namespaced: true,
	state: {
		domains: []
	},
	getters: {
		domain: function(state) {
			return id => {
				let n = false;
				state.buckets.map(bucket => {
					if (bucket._id === id) {
						n = bucket;
					}
				});
				return n;
			};
		},
		domainImage: function(state) {
			return href => {
				let n = false;
				state.domains.map(domain => {
					if (domain.key === href) {
						n = domain.data;
					}
				});
				if (n && n.logo) {
					return n.logo.url;
				} else {
					return false;
				}
			};
		},
		favicon: function(state) {}
	},
	mutations: {
		ADD_DOMAIN: function(state, domainData) {
			let pushed = false;
			state.domains = state.domains.map(d => {
				if (d.key === domainData.key) {
					d.data = domainData.data;
					pushed = true;
				}
				return d;
			});
			if (!pushed) {
				state.domains.push(domainData);
			}
		},
		SAVE_CACHE: function(state) {
			var data = {
				domains: state.domains
			};
			data = JSON.stringify(data);
			localStorage.setItem('cache', data);
		},
		RESTORE_CACHE: function(state) {
			var cache = localStorage.getItem('cache');
			if (cache) {
				cache = JSON.parse(cache);
				state.domains = cache.domains || [];
			}
		},
		CLEAR_CACHE: function(state) {
			state.domains = [];
			localStorage.setItem('cache', JSON.stringify({}));
		},
		SET_DOMAINS: function(state, domains) {}
	},
	actions: {
		init: function(context) {
			context.commit('RESTORE_CACHE');
		},
		clearCache: function(context) {
			context.commit('CLEAR_CACHE');
		},
		save: function(context, obj) {
			let key = obj.key;
			let value = obj.value;
			let newObject = {};
			newObject[key] = value;
			//storageManager.set(newObject);
		},
		get: function(context, key) {
			return new Promise(resolve => {
				// storageManager.get(key).then((data) => {
				// 	resolve(data);
				// });
			});
		},
		fetchMetadata: function(context, domain) {
			if (!ignoreList.includes(domain)) {
				var apiPath = context.rootState.baseUrl + '/metadata';
				var form = {
					url: domain
				};
				return new Promise((resolve, reject) => {
					axios.post(apiPath, form).then(res => {
						if (res.data) {
							context.commit('ADD_DOMAIN', {
								key: domain,
								data: res.data
							});
							context.commit('SAVE_CACHE');
						}
						resolve(res.data);
					});
				});
			}
		}
	}
};

export default store;
